import React from "react";
import {IFrameModalMessageIds} from "@emburse/ui-complex";
import {Box, Typography, useTheme} from "@emburse/ui-core";
import {useTranslation} from 'react-i18next';
import {BaseConfigurationContext} from "shared/context/BaseConfigurationContext";

const HEIGHT = '60px';

export const Header = () => {
    const {t, i18n} = useTranslation();
    const theme = useTheme();
    const {isInsideEmbark} = React.useContext(BaseConfigurationContext);
    const [title, setTitle] = React.useState<string>(t('configurationTitle'));

    const headerSx = React.useMemo(() => ({
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        lineHeight: HEIGHT,
        height: HEIGHT,
        backgroundColor: '#fff',
        zIndex: 1000
    }), [theme.palette.grey]);

    const updateEmbarkModalTitle = React.useCallback((title: string) => {
        if (isInsideEmbark) {
            window.parent.postMessage({message: IFrameModalMessageIds.headerTitle, value: title}, '*');
        }
        setTitle(title);
    }, [isInsideEmbark]);

    React.useEffect(() => {
        if (isInsideEmbark) {
            updateEmbarkModalTitle(t('configurationTitle'));
            window.parent.postMessage({message: IFrameModalMessageIds.headerShowClose, value: true}, '*');
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        if (i18n.resolvedLanguage) {
            const newTitle = i18n.t('configurationTitle');
            updateEmbarkModalTitle(newTitle);
        }
    }, [i18n, updateEmbarkModalTitle]);

    React.useEffect(() => {
        // Prepare body to have right background color for browsers who have a different theme
        document.body.style.backgroundColor = theme.palette.background.paper;
    }, [theme]);

    return (
        <>
            {!isInsideEmbark &&
                <Box sx={headerSx}>
                    <Typography variant='h5' sx={{lineHeight: HEIGHT, marginLeft: '0.5em'}}>{title}</Typography>
                </Box>
            }
        </>
    );
};